/**
 * passDispTypeの種別定数
 */
export const PASS_DISP_TYPE = {
  QR_SLIDER: "QrSlider",
};
